// src/mixins/datatableMixin.js

export default {
    data() {
      return {
        list: {},
        tableData: {
          data: [],
          pagination: '',
          detail: false,
          excel: false,
          searchable: {
            visible: true,
            placeholder: ''
          }
        },
        isLoading: false,
        pageLoading: false,
        endpoint: '',
        params: {
          per_page: 50,
          page: 1
        },
        searchParams:{}, 
        sort:{ column: null, order:null},
        searchQuery: '',
        exportName: ''
      };
    },
  
    created() {
      if(this.pagination != 'pagination'){
        window.addEventListener('scroll', this.handleScroll);
        const windowHeight = window.innerHeight;
        if(windowHeight > 2000){
          this.params.per_page = 100;
        }  
      }

      // eslint-disable-next-line no-console
      console.log('mixin', this.disableAutoLoad)

      if (this.disableAutoLoad) return;

      this.loadPage();
    },
    
    destroyed() {
      if(this.pagination != 'pagination'){
         window.removeEventListener('scroll', this.handleScroll);
      }
    },
  
    methods: {
      handleScroll() {

        const scrollY = window.scrollY || document.documentElement.scrollTop;
        const documentHeight = document.documentElement.scrollHeight;
        const windowHeight = window.innerHeight;

        if (scrollY + windowHeight >= documentHeight - 10) {
          this.loadMore(this.params.page + 1);
        }
      },
      
      /*
      async loadPage() {
        this.params.page === 1 ? this.isLoading = true : this.pageLoading = true;
  
        try {
          const response = await this.$http.post(this.endpoint, {
            params: this.params,
            sort_column: this.sortColumn,
            sort_crder: this.sortOrder,
            search_query: this.searchQuery
          });
  
          if (this.params.page === 1) {
            this.tableData.data = response.data.data;
          } else {
            this.tableData.data = [...this.tableData.data, ...response.data.data];
          }
  
          this.tableData.pagination = response.data.meta;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('Veri yüklenirken bir hata oluştu:', error);
        } finally {
          this.params.page === 1 ? this.isLoading = false : this.pageLoading = false;
        }
      },
      */
      loadMore(page) {
        if (this.isLoading || this.pageLoading) return;
  
        if (this.tableData.pagination.current_page < this.tableData.pagination.last_page) {
          this.params.page = page;
          this.loadPage();
        }
      },
  
      reLoadPage(query) {
        this.params.page = 1;
        this.searchQuery = query;
        this.loadPage();
      },
      
      pageChange(page){
        if (this.isLoading) return;

        this.params.page = page;
        this.loadPage();
      },

      handleSortColumn(columnKey, sortOrder) {
        if (this.isLoading) return;
  
        this.sort.column = columnKey;
        this.sort.order = sortOrder;

        
        this.params.page = 1;
        this.loadPage();
      },

      async excelExport() {

        const currentDate = new Date();
  
        const filename = `${currentDate.getFullYear()}${('0' + (currentDate.getMonth() + 1)).slice(-2)}${('0' + currentDate.getDate()).slice(-2)}${('0' + currentDate.getHours()).slice(-2)}${('0' + currentDate.getMinutes()).slice(-2)}${('0' + currentDate.getSeconds()).slice(-2)}_${this.exportName}.xlsx`;
  
        this.$http.post(this.endpoint + '?excel=true', this.searchParams, { responseType: 'blob' })
        .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            link.setAttribute('type', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        })
        .catch(error => {
            // eslint-disable-next-line no-console
            console.error('Excel dosyası indirilirken bir hata oluştu:', error);
        });
      },

    }
  };